import React from 'react'
import { Card, CardContent, Box, Skeleton, Stack } from '@mui/material'

export const AutomationsSkeleton: React.FC = () => {
  return (
    <Card sx={{ borderRadius: 3, mb: 3 }}>
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            gap: 2,
            mb: 3,
          }}
        >
          <Skeleton variant="text" width={180} height={28} />
          <Skeleton variant="rounded" width={130} height={36} sx={{ borderRadius: 1.5, width: { xs: '100%', sm: 130 } }} />
        </Box>
        <Stack spacing={2}>
          {Array.from({ length: 4 }).map((_, index) => (
            <Skeleton key={index} variant="rounded" height={60} sx={{ borderRadius: 2 }} />
          ))}
        </Stack>
      </CardContent>
    </Card>
  )
}

export default AutomationsSkeleton
